<template>
  <section>
    <el-row class="row">
      <el-col class="col-md-9 cl-left" :span="17">
        <div class="recommend-index">
          <div class="recommend-top">
            <div
              id="carouselExampleIndicators"
              class="carousel slide"
              data-ride="carousel"
            >
              <el-carousel v-if="publicBannerList.length >= 1">
                <el-carousel-item
                  class="el-carousel__item"
                  v-for="(item, index) in publicBannerList"
                  :key="index"
                  style="cursor: pointer"
                >
                  <!-- <h3 class="small">{{ item.thumb }}</h3> -->
                  <span @click="goDetails(item)"
                    ><img :src="item.thumb" alt="" v-if="item.thumb"
                  /></span>
                </el-carousel-item>
              </el-carousel>
              <el-carousel v-else>
                <el-carousel-item
                  class="el-carousel__item"
                  v-for="(item, index) in 1"
                  :key="index"
                >
                  <!-- <h3 class="small">{{ item.thumb }}</h3> -->
                  <!-- <img :src="item.thumb" alt="" v-if="item.thumb"> -->
                </el-carousel-item>
              </el-carousel>
              <a
                class="carousel-control-prev"
                href="#carouselExampleIndicators"
                role="button"
                data-slide="prev"
              >
                <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                <span class="sr-only">Previous</span>
              </a>
              <a
                class="carousel-control-next"
                href="#carouselExampleIndicators"
                role="button"
                data-slide="next"
              >
                <span class="carousel-control-next-icon" aria-hidden="true"></span>
                <span class="sr-only">Next</span>
              </a>
            </div>
          </div>
          <div class="recommend-bottom">
            <div class="recommend-item">
              <a href="calmlog-details.html"
                ><img src="temporary-img/recommended-left.jpg" class="img-fluid" alt=""
              /></a>
            </div>
            <div class="recommend-item">
              <a href="calmlog-details.html"
                ><img src="temporary-img/recommended-right.jpg" class="img-fluid" alt=""
              /></a>
            </div>
          </div>
        </div>
        <!-- 公告详情 -->
        <div class="home_img" v-if="publicShuffling != undefined" style="cursor: pointer">
          <div
            class="clearfix"
            style="position: relative; left: 50%; transform: translate(-16%, 0%)"
          >
            <div class="left img">
              <img src="@/imgs/icon_1.png" alt="" />
            </div>
            <div class="left">
              <el-carousel style="height: auto" class="carousel_banner">
                <el-carousel-item
                  v-for="(item, index) in publicShuffling"
                  :key="index"
                  @click.native="announcementDetails(item)"
                  style="cursor: pointer"
                >
                  {{ item.title }}
                </el-carousel-item>
              </el-carousel>
            </div>
          </div>
        </div>
      </el-col>
      <el-col
        class="col-md-3 cl-right"
        :span="6"
        style="maright-left: 16px; margin-top: 20px"
      >
        <div class="right-card" v-if="userInfo != null && userInfo.user_nickname">
          <div class="right-card-main">
            <!-- 右侧 -->
            <div class="right-card-title" @click="otherPage" style="cursor: pointer">
              <img
                :src="userInfo.head_img"
                style="width: 52px; height: 52px; border-radius: 100%"
                v-if="userInfo.head_img"
                alt=""
              />
              <img src="@/imgs/header.png" alt="" v-else />
              <div>{{ userInfo.user_nickname }}</div>
              <el-divider></el-divider>
            </div>
            <div class="cl-code">
              <ul class="clearfix">
                <li class="left code-left">
                  <p>{{ userNumber.gz_number }}</p>
                  <p>{{ $t("关注") }}</p>
                </li>
                <li class="left code-left">
                  <p>{{ userNumber.fans_number }}</p>
                  <p>{{ $t("粉丝") }}</p>
                </li>
                <li class="left code-left">
                  <p>{{ userNumber.getlike_number }}</p>
                  <p>{{ $t("获赞") }}</p>
                </li>
              </ul>
              <div class="professional">
                <p>
                  <span>{{ $t("职业") }}：</span>
                  <span
                    v-if="userNumber.work != '' && userNumber.work != undefined"
                    style="
                      width: 200px;
                      display: inline-flex;
                      height: 20px;
                      overflow: hidden;
                      white-space: break-spaces;
                      text-overflow: ellipsis;
                    "
                  >
                    <el-tooltip
                      class="item"
                      effect="dark"
                      :content="userNumber.work"
                      placement="top"
                    >
                      <span>{{ userNumber.work }}</span>
                    </el-tooltip></span
                  ><span v-else>{{ $t("暂无") }}</span>
                </p>
                <p>
                  {{ $t("入住时间：") }}
                  <span
                    v-if="userNumber.in_time != '' && userNumber.in_time != undefined"
                    >{{ userNumber.in_time }}</span
                  ><span v-else>0</span>
                </p>
                <p
                  v-if="userNumber.sign != '' && userNumber.sign != undefined"
                  style="
                    width: 200px;
                    display: inline-flex;
                    height: 20px;
                    overflow: hidden;
                    white-space: break-spaces;
                    text-overflow: ellipsis;
                  "
                >
                  <el-tooltip
                    class="item"
                    effect="dark"
                    :content="userNumber.sign"
                    placement="top"
                  >
                    <span
                      style="
                        overflow: hidden;
                        white-space: nowrap;
                        text-overflow: ellipsis;
                      "
                      >{{ userNumber.sign }}</span
                    >
                  </el-tooltip>
                </p>
                <p v-else>{{ $t("该用户还没有填写签名…") }}</p>
              </div>
            </div>
          </div>
        </div>
        <div class="right-card" v-else>
          <div class="right-card-main">
            <!-- 右侧 -->
            <div class="right-card-Logion" @click="otherPage" style="cursor: pointer">
              <div class="login">{{ $t("欢迎登录") }}</div>
              <div class="login_info">
                <span>{{ $t("Hi，您还没有进行登录请前往进行登录") }}</span>
              </div>
              <div class="flooter">
                <el-button @click="goLogin" style="cursor: pointer">{{
                  $t("登录")
                }}</el-button>
              </div>
            </div>
          </div>
        </div>
      </el-col>
    </el-row>
  </section>
</template>

<script>
import Service from "@/api/request/index.js";
export default {
  name: "publicBanner",
  data() {
    return {
      userNumber: {}, //用户信息
      userInfo: {}, //用户信息
    };
  },
  props: ["publicBannerList", "publicShuffling"],
  created() {
    // 所有消息数量
    this.userInfo = JSON.parse(localStorage.getItem("USER_INFO"));
    this.post62bd01fd4eb3d();
  },

  methods: {
    // 轮播图跳转页面
    goDetails(item) {
      console.log(item.article_type);
      if (item.article_type == 1) {
        return this.$router.push({
          url: "/hafaDetails",
          name: "hafaDetails",
          query: { userId: item.article_id, report_article_type: item.article_type },
        });
      } else if (item.article_type == 2) {
        return this.$router.push({
          url: "/bbsDetails",
          name: "bbsDetails",
          query: { userId: item.article_id, report_article_type: item.article_type },
        });
      } else if (item.article_type == 3) {
        return this.$router.push({
          url: "/businessmanDetails",
          name: "businessmanDetails",
          query: { userId: item.article_id, report_article_type: item.article_type },
        });
      } else if (item.article_type == 4) {
        return this.$router.push({
          url: "/todayDiscountDetails",
          name: "todayDiscountDetails",
          query: { userId: item.article_id, report_article_type: item.article_type },
        });
      } else if (item.article_type == 5) {
        return this.$router.push({
          url: "/localLifeDetails",
          name: "localLifeDetails",
          query: { userId: item.article_id, report_article_type: item.article_type },
        });
      } else if (item.article_type == 6) {
        return this.$router.push({
          url: "/tradingDetails",
          name: "tradingDetails",
          query: { userId: item.article_id, report_article_type: item.article_type },
        });
      } else if (item.article_type == 7) {
        return this.$router.push({
          url: "/rentHouseDetails",
          name: "rentHouseDetails",
          query: { userId: item.article_id, report_article_type: item.article_type },
        });
      } else if (item.article_type == 8) {
        return this.$router.push({
          url: "/twoHandcartDetails",
          name: "twoHandcartDetails",
          query: { userId: item.article_id, report_article_type: item.article_type },
        });
      } else if (item.article_type == 9) {
        return this.$router.push({
          url: "/recruitmentDetails",
          name: "recruitmentDetails",
          query: { userId: item.article_id, report_article_type: item.article_type },
        });
      } else if (item.article_type == 10) {
        return this.$router.push({
          url: "/petDetails",
          name: "petDetails",
          query: { userId: item.article_id, report_article_type: item.article_type },
        });
      }
    },
    otherPage() {
      this.$router.push({
        url: "/othersPage",
        name: "othersPage",
        query: {
          user_id: this.userInfo.id,
        },
      });
    },
    // 公告详情
    announcementDetails(item) {
      console.log(item);
      this.$router.push({
        url: "/announcement",
        name: "announcement",
        query: {
          id: item.id,
        },
      });
    },
    // 登录
    goLogin() {
      this.$router.push("/login");
    },
    // 所有消息数量
    // post62bd50a65532f() {
    //     Service.post62bd50a65532f({UserId:this.userInfo.id}).then(res=>{
    //         console.log("res", res)
    //         if(res.code==1) {
    //             this.userNumber=res.data;
    //             localStorage.setItem('userNumber',JSON.stringify(res.data))
    //         }
    //     })
    // },
    post62bd01fd4eb3d() {
      Service.post62bd01fd4eb3d({
        user_id: (this.userInfo && this.userInfo.id) || 0,
      }).then((res) => {
        console.log("res", res);
        if (res.code == 1) {
          this.userNumber = res.data;
          localStorage.setItem("userNumber", JSON.stringify(res.data));
        }
      });
    },
  },
};
</script>

<style scoped lang="scss">
@import "themePath/Monitor/cl-css";
@import "themePath/railscasts";
/deep/ .right-card {
  width: 330px;
  height: 356px;
  // padding: 24px;
}
/deep/ .right-card-main {
  height: 100%;
  padding: 24px;
  box-sizing: border-box;
}
/deep/ .right-card-title {
  text-align: center;
}
/deep/ .el-carousel__container {
  height: 356px;
}
/deep/ .cl-left {
  margin-bottom: 0;
  margin-top: 20px;
}
.code-left {
  width: 30%;
  position: relative;
  p:first-child {
    font-size: 16px;
    font-family: PingFang SC-Medium, PingFang SC;
    font-weight: bold;
    color: #333333;
  }
}

.code-left::after {
  width: 1px;
  height: 28px;
  background: #eeeeee;
  content: "";
  display: block;
  clear: both;
  position: absolute;
  right: -1px;
  top: 22px;
}
.code-left:last-child::after {
  width: 0;
}
.professional {
  margin-top: 35px;
  p {
    text-align: left;
    // margin-bottom: 16px;
  }
}
.home_img {
  text-align: center;
  width: 850px;
  height: 40px;
  background: #000000;
  border-radius: 4px 4px 0px 0px;
  opacity: 0.5;
  color: #ffffff;
  font-size: 16px;
  font-family: PingFang SC-Regular, PingFang SC;
  font-weight: 400;
  color: #ffffff;
  line-height: 40px;
  position: absolute;
  top: 20px;
  z-index: 99;
  img {
    width: 16px;
    height: 16px;
    margin-right: 8px;
    img {
      width: 100%;
      height: 100%;
      object-fit: fill;
    }
  }
}
.right-card-Logion {
  text-align: center;
  .login {
    height: 30px;
    font-size: 22px;
    font-family: PingFang SC-Medium, PingFang SC;
    font-weight: bold;
    color: #333333;
    margin-top: 93px;
    margin-bottom: 28px;
    position: relative;
    &::after {
      display: block;
      content: "";
      background: #fee60f;
      width: 88px;
      height: 4px;
      margin-top: 8px;
      position: absolute;
      left: 50%;
      transform: translate(-50%, 0);
    }
  }
  .login_info span {
    display: inline-block;
    width: 160px;
    height: 44px;
    font-size: 16px;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;
    color: #999999;
  }
  .flooter {
    margin-top: 40px;
    /deep/ .el-button {
      width: 182px;
      height: 48px;
      background: #fee60f;
      border-radius: 4px 4px 4px 4px;
      opacity: 1;
      font-size: 18px;
      font-family: PingFang SC-Regular, PingFang SC;
      font-weight: 400;
      color: #333333;
      border: 0;
    }
  }
}
.carousel_banner {
  /deep/ .el-carousel__container {
    height: 40px !important;
    width: 355px;
  }
  /deep/ .el-carousel__button {
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/publicBanner.vue